import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import qs from "qs";
import router from "../router/index.js";
import createPersistedState from "vuex-persistedstate";
import jwtDecode from "jwt-decode";
import { saveAs } from "file-saver";

Vue.use(Vuex);

axios.defaults.baseURL = "https://api-portal-empleado.casi.es";

//axios.defaults.baseURL = 'http://192.168.20.206:3004';
axios.defaults.headers.common["Content-Type"] =
  "application/x-www-form-urlencoded";

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      // Realizar acciones específicas para el error 401
      // Por ejemplo, redireccionar a la página de inicio de sesión
      store.commit("cerrarSesion");
      store.commit("limpiarPerfil");
    }
    return Promise.reject(error);
  },
);

const store = new Vuex.Store({
  state: {
    token: "",
    textoErrorAutenticacion: "",
    autenticando: false,
    correoRecuperacionContraseniaEnviado: false,
    nuevaContraseniaEstablecida: false,
    perfil: {},
    enviandoDatosFormulario: false,
    guardadoOK: false,
    datosVacacionesParaValoracion: { message: "Buscando información..." },
    ultPaginaVisitada: "",
    anuncios: [],
    modoApp: false,
    status: "produccion",
  },
  getters: {},
  mutations: {
    registrarUltPaginaVisitada(state, route) {
      state.ultPaginaVisitada = route;
    },
    establecerTextoErrorAutenticacion(state, texto) {
      state.textoErrorAutenticacion = texto;
    },
    establecerToken(state, token) {
      state.token = token;
      axios.defaults.headers.common["access-token"] = token;
    },
    establecerModoApp(state, estado) {
      console.log("estableciendo estado del modoApp a:", estado);
      state.modoApp = estado;
    },
    establecerEstadoAutenticacion(state, estado) {
      state.autenticando = estado;
    },
    cerrarSesion(state) {
      state.token = "";
      router.replace("/login");
    },
    establecerEnvioCorreoRecuperacionPass(state, estado) {
      state.correoRecuperacionContraseniaEnviado = estado;
      if (estado) setTimeout(() => router.push("/login"), 5000);
    },
    establecerNuevaContraseniaEstablecida(state, estado) {
      state.nuevaContraseniaEstablecida = estado;
      if (estado) setTimeout(() => window.location.reload(), 5000);
    },
    establecerPerfil(state, perfil) {
      state.perfil = perfil;
    },
    establecerAnuncios(state, anuncios) {
      state.anuncios = anuncios;
    },
    limpiarPerfil(state) {
      state.perfil = {};
      axios.defaults.headers.common["access-token"] = state.token;
    },
    limpiarAnuncios(state) {
      state.anuncios = [];
    },
    establecerEstadoEnviandoDatosFormulario(state, estado) {
      state.enviandoDatosFormulario = estado;
    },
    establecerGuardadoOK(state, estado) {
      state.guardadoOK = estado;
    },
    actualizarVacaciones(state, vacaciones) {
      // console.log(vacaciones);
      const registros = state.perfil.vacaciones.registros || [];
      const arrayRegistros = Array.isArray(registros) ? registros : [registros];

      state.perfil.vacaciones.registros = arrayRegistros;

      if (Object.keys(vacaciones.registros).length == 1) {
        //borrar vacaciones
        state.perfil.vacaciones.registros = arrayRegistros.filter(
          (registro) => registro.id != vacaciones.registros.id,
        );
      }

      if (Object.keys(vacaciones.registros).length > 1) {
        //añadir vacaciones
        state.perfil.vacaciones.registros.unshift(vacaciones.registros);
      }

      state.perfil.vacaciones.resumen = vacaciones.resumen;
    },
    actualizarAnticipos(state, anticipo) {
      const anticipos = state.perfil.anticipos || [];
      const arrayAnticipos = Array.isArray(anticipos) ? anticipos : [anticipos];

      state.perfil.anticipos = arrayAnticipos;

      if (Object.keys(anticipo).length == 1) {
        //borrar anticipo
        return (state.perfil.anticipos = arrayAnticipos.filter(
          (anticipo_) => anticipo_.id != anticipo.id,
        ));
      }

      if (Object.keys(anticipo).length > 1) {
        //añadir anticipo
        state.perfil.anticipos.unshift(anticipo);
      }
    },
    actualizarPermisos(state, permiso) {
      const permisos = state.perfil.permisos || [];
      const arrayPermisos = Array.isArray(permisos) ? permisos : [permisos];
      const posicion = arrayPermisos.findIndex((e) => e.id == permiso.id);

      state.perfil.permisos = arrayPermisos;

      if (Object.keys(permiso).length == 1) {
        //borra
        return (state.perfil.permisos = arrayPermisos.filter(
          (permiso_) => permiso_.id != permiso.id,
        ));
      }

      if (posicion > -1) {
        //actualiza
        return (state.perfil.permisos[posicion] = permiso);
      }

      state.perfil.permisos.unshift(permiso); //añade
    },
    actualizarModificaciones(state, modificacion) {
      const modificaciones = state.perfil.modificaciones || [];
      const arrayModificaciones = Array.isArray(modificaciones)
        ? modificaciones
        : [modificaciones];

      state.perfil.modificaciones = arrayModificaciones;

      if (Object.keys(modificacion).length == 1) {
        //borrar modificacion
        return (state.perfil.modificaciones = arrayModificaciones.filter(
          (modificacion_) => modificacion_.id != modificacion.id,
        ));
      }

      if (Object.keys(modificacion).length > 1) {
        //añadir modificación
        state.perfil.modificaciones.unshift(modificacion);
      }
    },
    actualizarFicheros(state, documentos) {
      //console.log(JSON.stringify(documentos));
      state.perfil.documentosPersonales = documentos.documentosPersonales;
      state.perfil.documentosGenerales = documentos.documentosGenerales;

      if (documentos.documentosGenerales.documentos) {
        const hayDocumentosPendientes =
          documentos.documentosGenerales.documentos.some(function (documento) {
            let acuse = documento.acuse * 1;
            let acusado = documento.acusado * 1;
            let firma = documento.firma * 1;
            let firmado = documento.firmado * 1;

            return (acuse && !acusado) || (firma && !firmado);
          });

        if (!hayDocumentosPendientes) {
          state.perfil.bloqueo = "0";
        }
      }
    },
    establecerdatosVacacionesParaValoracion(
      state,
      datosVacacionesParaValoracion,
    ) {
      state.datosVacacionesParaValoracion = datosVacacionesParaValoracion;
    },
    establecerStatus(state, status) {
      state.status = status;
    },
  },
  actions: {
    autenticar({ commit, dispatch }, datosAutenticacion) {
      const config = {
        method: "post",
        url: "/api/login",
        data: datosAutenticacion,
      };

      commit("establecerEstadoAutenticacion", true);

      axios
        .request(config)
        .then((response) => {
          // console.log(JSON.stringify(response.data));

          commit("establecerToken", response.data.token);

          dispatch("obtenerPerfil");

          setTimeout(function () {
            commit("establecerEstadoAutenticacion", false);
            if (router.currentRoute.query.from) {
              router.replace(router.currentRoute.query.from);
              return;
            }
            if (!router.currentRoute.query.from) {
              router.push("/");
            }
          }, 500);
        })
        .catch((error) => {
          console.log(error.response.data);
          setTimeout(function () {
            if (error.response.status === 401) {
              commit(
                "establecerTextoErrorAutenticacion",
                error.response.data.mensaje,
              );
            }
            commit("establecerEstadoAutenticacion", false);
          }, 500);
        });
    },
    obtenerPerfil({ commit }) {
      const config = {
        method: "get",
        url: "/api/perfil",
      };

      commit("limpiarPerfil");

      axios
        .request(config)
        .then((response) => {
          //console.log(JSON.stringify(response.data));
          commit("establecerPerfil", response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    obtenerAnuncios({ commit }) {
      const config = {
        method: "get",
        url: "/api/anuncios",
      };

      commit("limpiarAnuncios");

      axios
        .request(config)
        .then((response) => {
          //console.log(JSON.stringify(response.data.data));
          commit("establecerAnuncios", response.data.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    enviarCorreoRecuperacionPass({ commit }, datosRecuperacion) {
      let data = qs.stringify({
        email: datosRecuperacion.email,
      });

      let config = {
        method: "post",
        url: "/api/recuperarPass",
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          console.log(JSON.stringify(response.data));

          let resultado = response.data[0][0].resultado;
          if (resultado == "OK") {
            setTimeout(() => {
              commit("establecerEnvioCorreoRecuperacionPass", true);
              //AVISANDO DEL SUBMIT A LA APP
              const target =
                window["cordova_iab"] ??
                window["webkit"]?.messageHandlers["cordova_iab"] ??
                window["opener"] ??
                window["parent"] ??
                window;

              const data = JSON.stringify({ event: "submit" });

              target.postMessage(data, "*");
              //FIN AVISANDO DEL SUBMIT A LA APP
            }, 500);
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            console.log(error.response.data);
            setTimeout(function () {
              console.log("hay un error");
            }, 500);
          }
          console.log(error);
        });
    },
    validarPeticionPass({ commit }, datosValidacion) {
      let data = qs.stringify({
        pid: datosValidacion.pid,
      });

      let config = {
        method: "post",
        url: "/api/validarPeticionPass",
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          let resultado = response.data[0][0].resultado;
          if (resultado == "KO") {
            router.push("/login");
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            console.log(error.response.data);
            setTimeout(function () {
              console.log("hay un error");
            }, 500);
          }
          console.log(error);
        });
    },
    establecerNuevaContrasenia({ commit }, datosNuevaContrasenia) {
      let data = qs.stringify({
        pid: datosNuevaContrasenia.pid,
        contrasenia: datosNuevaContrasenia.contrasenia,
      });

      let config = {
        method: "post",
        url: "/api/establecerNuevaPass",
        data: data,
      };

      axios
        .request(config)
        .then((response) => {
          let resultado = response.data[0][0].resultado;

          if (resultado == "OK") {
            commit("establecerNuevaContraseniaEstablecida", true);
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            console.log(error.response.data);
            setTimeout(function () {
              console.log("hay un error");
            }, 500);
          }
          console.log(error);
        });
    },
    enviarDatosNuevoPermiso({ commit }, datosFormularioNuevoPermiso) {
      let formData = new FormData();
      formData.append(
        "idTipoAusencia",
        datosFormularioNuevoPermiso.idTipoAusencia,
      );
      formData.append("fechaDesde", datosFormularioNuevoPermiso.fechaDesde);
      formData.append("fechaHasta", datosFormularioNuevoPermiso.fechaHasta);
      formData.append("horaDesde", datosFormularioNuevoPermiso.horaDesde);
      formData.append("horaHasta", datosFormularioNuevoPermiso.horaHasta);
      formData.append(
        "observaciones",
        !!datosFormularioNuevoPermiso.observaciones
          ? datosFormularioNuevoPermiso.observaciones
          : "",
      );

      !!datosFormularioNuevoPermiso.adjunto_1
        ? formData.append(
            "adjunto_1",
            datosFormularioNuevoPermiso.adjunto_1,
            datosFormularioNuevoPermiso.adjunto_1.name.replace(
              /[^a-zA-Z0-9-_\s.]/g,
              "",
            ),
          )
        : formData.append("adjunto_1", datosFormularioNuevoPermiso.adjunto_1);

      !!datosFormularioNuevoPermiso.adjunto_2
        ? formData.append(
            "adjunto_2",
            datosFormularioNuevoPermiso.adjunto_2,
            datosFormularioNuevoPermiso.adjunto_2.name.replace(
              /[^a-zA-Z0-9-_\s.]/g,
              "",
            ),
          )
        : formData.append("adjunto_2", datosFormularioNuevoPermiso.adjunto_2);

      !!datosFormularioNuevoPermiso.adjunto_3
        ? formData.append(
            "adjunto_3",
            datosFormularioNuevoPermiso.adjunto_3,
            datosFormularioNuevoPermiso.adjunto_3.name.replace(
              /[^a-zA-Z0-9-_\s.]/g,
              "",
            ),
          )
        : formData.append("adjunto_3", datosFormularioNuevoPermiso.adjunto_3);

      // formData.append('adjunto_1', datosFormularioNuevoPermiso.adjunto_1, datosFormularioNuevoPermiso.adjunto_1.name.replace(/[^a-zA-Z0-9-_\s.]/g, ''));
      // formData.append('adjunto_2', datosFormularioNuevoPermiso.adjunto_2, datosFormularioNuevoPermiso.adjunto_2.name.replace(/[^a-zA-Z0-9-_\s.]/g, ''));
      // formData.append('adjunto_3', datosFormularioNuevoPermiso.adjunto_3, datosFormularioNuevoPermiso.adjunto_3.name.replace(/[^a-zA-Z0-9-_\s.]/g, ''));

      commit("establecerEstadoEnviandoDatosFormulario", true);

      axios
        .post("/api/permiso", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          // console.log('--------response---------');
          // console.log(response);
          // console.log('-------------------------');
          commit("establecerEstadoEnviandoDatosFormulario", false);
          commit("actualizarPermisos", response.data.permiso);
          commit("establecerGuardadoOK", true);
        })
        .catch((error) => {
          commit("establecerEstadoEnviandoDatosFormulario", false);
          console.error(error);
          throw error;
        });
    },
    enviarDatosNuevasVacaciones({ commit }, datosFormularioNuevasVacaciones) {
      const config = {
        method: "post",
        url: "/api/vacaciones",
        data: datosFormularioNuevasVacaciones,
      };

      commit("establecerEstadoEnviandoDatosFormulario", true);

      axios
        .request(config)
        .then((response) => {
          // console.log('--------response---------');
          // console.log(response);
          // console.log('-------------------------');

          commit("actualizarVacaciones", response.data.vacaciones);
          commit("establecerGuardadoOK", true);

          setTimeout(function () {
            commit("establecerEstadoEnviandoDatosFormulario", false);
          }, 3000);
        })
        .catch((error) => {
          commit("establecerEstadoEnviandoDatosFormulario", false);
          console.error(error);
          throw error;
        });
    },
    enviarDatosNuevoAnticipo({ commit }, datosFormularioNuevoAnticipo) {
      const config = {
        method: "post",
        url: "/api/anticipo",
        data: datosFormularioNuevoAnticipo,
      };

      commit("establecerEstadoEnviandoDatosFormulario", true);

      axios
        .request(config)
        .then((response) => {
          // console.log('--------response---------');
          // console.log(response);
          // console.log('-------------------------');
          commit("establecerEstadoEnviandoDatosFormulario", false);
          commit("actualizarAnticipos", response.data.anticipo);
          commit("establecerGuardadoOK", true);
        })
        .catch((error) => {
          commit("establecerEstadoEnviandoDatosFormulario", false);
          // Maneja el error de alguna manera
          console.error(error);
          throw error;
        });
    },
    enviarDatosNuevaModificacionDatosPersonales(
      { commit },
      datosFormularioNuevaModificacionDatosPersonales,
    ) {
      let formData = new FormData();

      formData.append(
        "idTipoModificacion",
        datosFormularioNuevaModificacionDatosPersonales.idTipoModificacion,
      );
      formData.append(
        "observaciones",
        !!datosFormularioNuevaModificacionDatosPersonales.observaciones
          ? datosFormularioNuevaModificacionDatosPersonales.observaciones
          : "",
      );

      !!datosFormularioNuevaModificacionDatosPersonales.adjunto_1
        ? formData.append(
            "adjunto_1",
            datosFormularioNuevaModificacionDatosPersonales.adjunto_1,
            datosFormularioNuevaModificacionDatosPersonales.adjunto_1.name.replace(
              /[^a-zA-Z0-9-_\s.]/g,
              "",
            ),
          )
        : formData.append(
            "adjunto_1",
            datosFormularioNuevaModificacionDatosPersonales.adjunto_1,
          );

      !!datosFormularioNuevaModificacionDatosPersonales.adjunto_2
        ? formData.append(
            "adjunto_2",
            datosFormularioNuevaModificacionDatosPersonales.adjunto_2,
            datosFormularioNuevaModificacionDatosPersonales.adjunto_2.name.replace(
              /[^a-zA-Z0-9-_\s.]/g,
              "",
            ),
          )
        : formData.append(
            "adjunto_2",
            datosFormularioNuevaModificacionDatosPersonales.adjunto_2,
          );

      !!datosFormularioNuevaModificacionDatosPersonales.adjunto_3
        ? formData.append(
            "adjunto_3",
            datosFormularioNuevaModificacionDatosPersonales.adjunto_3,
            datosFormularioNuevaModificacionDatosPersonales.adjunto_3.name.replace(
              /[^a-zA-Z0-9-_\s.]/g,
              "",
            ),
          )
        : formData.append(
            "adjunto_3",
            datosFormularioNuevaModificacionDatosPersonales.adjunto_3,
          );

      // formData.append('adjunto_1', datosFormularioNuevaModificacionDatosPersonales.adjunto_1);
      // formData.append('adjunto_2', datosFormularioNuevaModificacionDatosPersonales.adjunto_2);
      // formData.append('adjunto_3', datosFormularioNuevaModificacionDatosPersonales.adjunto_3);

      // console.log(JSON.stringify(datosFormularioNuevaModificacionDatosPersonales));

      commit("establecerEstadoEnviandoDatosFormulario", true);

      axios
        .post("/api/modificacion-datos-personales", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          // console.log('--------response---------');
          // console.log(response);
          // console.log('-------------------------');
          commit("establecerEstadoEnviandoDatosFormulario", false);
          commit("actualizarModificaciones", response.data.modificacion);
          commit("establecerGuardadoOK", true);
        })
        .catch((error) => {
          commit("establecerEstadoEnviandoDatosFormulario", false);
          console.error(error);
          throw error;
        });
    },
    borrarPermiso({ commit }, permiso) {
      const config = {
        method: "delete",
        url: `/api/permiso/${permiso.id}`,
      };

      axios
        .request(config)
        .then((response) => {
          // console.log('--------response---------');
          // console.log(response);
          // console.log('-------------------------');
          commit("actualizarPermisos", response.data.permiso);
          commit("establecerGuardadoOK", true);
        })
        .catch((error) => {
          console.error(error);
          throw error;
        });
    },
    borrarVacaciones({ commit }, vacaciones) {
      //ESTAMOS AQUI
      const config = {
        method: "delete",
        url: `/api/vacaciones/${vacaciones.id}`,
      };

      // console.log(config);

      axios
        .request(config)
        .then((response) => {
          // console.log('--------response---------');
          // console.log(response);
          // console.log('-------------------------');
          commit("actualizarVacaciones", response.data.vacaciones);
          commit("establecerGuardadoOK", true);
        })
        .catch((error) => {
          // Maneja el error de alguna manera
          console.error(error);
          throw error;
        });
    },
    borrarAnticipo({ commit }, anticipo) {
      const config = {
        method: "delete",
        url: `/api/anticipos/${anticipo.id}`,
      };

      axios
        .request(config)
        .then((response) => {
          // console.log('--------response---------');
          // console.log(response);
          // console.log('-------------------------');
          commit("actualizarAnticipos", response.data.anticipo);
          commit("establecerGuardadoOK", true);
        })
        .catch((error) => {
          console.error(error);
          throw error;
        });
    },
    borrarModificacion({ commit }, modificacion) {
      const config = {
        method: "delete",
        url: `/api/modificaciones-datos-personales/${modificacion.id}`,
      };

      axios
        .request(config)
        .then((response) => {
          // console.log('--------response---------');
          // console.log(response);
          // console.log('-------------------------');
          commit("actualizarModificaciones", response.data.modificacion);
          commit("establecerGuardadoOK", true);
        })
        .catch((error) => {
          console.error(error);
          throw error;
        });
    },
    enviarDatosEdicionPermiso({ commit }, datosFormularioEdicionPermiso) {
      let formData = new FormData();
      formData.append("fechaDesde", datosFormularioEdicionPermiso.fechaDesde);
      formData.append("fechaHasta", datosFormularioEdicionPermiso.fechaHasta);
      formData.append("horaDesde", datosFormularioEdicionPermiso.horaDesde);
      formData.append("horaHasta", datosFormularioEdicionPermiso.horaHasta);
      formData.append(
        "observaciones",
        !!datosFormularioEdicionPermiso.observaciones
          ? datosFormularioEdicionPermiso.observaciones
          : "",
      );

      datosFormularioEdicionPermiso.adjunto_1 instanceof File
        ? formData.append(
            "adjunto_1",
            datosFormularioEdicionPermiso.adjunto_1,
            datosFormularioEdicionPermiso.adjunto_1.name.replace(
              /[^a-zA-Z0-9-_\s.]/g,
              "",
            ),
          )
        : formData.append("adjunto_1", datosFormularioEdicionPermiso.adjunto_1);

      datosFormularioEdicionPermiso.adjunto_2 instanceof File
        ? formData.append(
            "adjunto_2",
            datosFormularioEdicionPermiso.adjunto_2,
            datosFormularioEdicionPermiso.adjunto_2.name.replace(
              /[^a-zA-Z0-9-_\s.]/g,
              "",
            ),
          )
        : formData.append("adjunto_2", datosFormularioEdicionPermiso.adjunto_2);

      datosFormularioEdicionPermiso.adjunto_3 instanceof File
        ? formData.append(
            "adjunto_3",
            datosFormularioEdicionPermiso.adjunto_3,
            datosFormularioEdicionPermiso.adjunto_3.name.replace(
              /[^a-zA-Z0-9-_\s.]/g,
              "",
            ),
          )
        : formData.append("adjunto_3", datosFormularioEdicionPermiso.adjunto_3);

      // formData.append('adjunto_1', datosFormularioEdicionPermiso.adjunto_1);
      // formData.append('adjunto_2', datosFormularioEdicionPermiso.adjunto_2);
      // formData.append('adjunto_3', datosFormularioEdicionPermiso.adjunto_3);

      commit("establecerEstadoEnviandoDatosFormulario", true);

      axios
        .put(
          `/api/permiso/${datosFormularioEdicionPermiso.idPermisoSeleccionado}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        )
        .then((response) => {
          // console.log('--------response---------');
          // console.log(response);
          // console.log('-------------------------');
          commit("establecerEstadoEnviandoDatosFormulario", false);
          commit("actualizarPermisos", response.data.permiso);
          commit("establecerGuardadoOK", true);
        })
        .catch((error) => {
          commit("establecerEstadoEnviandoDatosFormulario", false);
          console.error(error);
          throw error;
        });
    },
    descargarAdjunto({ commit, state }, datosAdjunto) {
      const { categoria, id, adjunto } = datosAdjunto;
      const nombreFichero = adjunto.split("/").pop();

      const url = `/api/${categoria}/${id}/descargar-adjunto?adjunto=${adjunto}`;

      const config = {
        method: "get",
        url: url,
        responseType: "blob",
      };

      if (state.modoApp) {
        const target =
          window["cordova_iab"] ??
          window["webkit"]?.messageHandlers["cordova_iab"] ??
          window["opener"] ??
          window["parent"] ??
          window;

        const data = JSON.stringify({
          event: "download",
          file_url: encodeURI(`${axios.defaults.baseURL}${url}`),
          file_name: nombreFichero,
        });

        console.log(
          `llamando al parent para para la descarga de un archivo adjunto: ${data}`,
        );

        target.postMessage(data, "*");

        return;
      }

      axios
        .request(config)
        .then((response) => {
          const downloadLink = document.createElement("a");

          downloadLink.href = window.URL.createObjectURL(response.data);
          downloadLink.download = nombreFichero;
          downloadLink.click();
          downloadLink.remove();
          setTimeout(() => window.URL.revokeObjectURL(downloadLink), 100);
        })
        .catch((error) => {
          console.error("Error al descargar y mostrar el archivo:", error);
        });
    },
    registrarVistaFicheros({ commit }, datosVistaFicheros) {
      const config = {
        method: "post",
        url: "/api/registroVistaFicheros",
        data: datosVistaFicheros,
      };

      axios
        .request(config)
        .then((response) => {
          // console.log('--------response---------');
          // console.log(response);
          // console.log('-------------------------');
          commit("actualizarFicheros", response.data);
        })
        .catch((error) => {
          console.error(error);
          throw error;
        });
    },
    descargarDocumentoPersonal({ commit, state }, datosDocumento) {
      const { documento } = datosDocumento;
      const nombreFichero = documento.split("/").pop();
      const url = `/api/documento-personal?documento=${documento}`;
      const config = {
        method: "get",
        url: url,
        responseType: "blob",
      };

      if (state.modoApp) {
        const target =
          window["cordova_iab"] ??
          window["webkit"]?.messageHandlers["cordova_iab"] ??
          window["opener"] ??
          window["parent"] ??
          window;

        const data = JSON.stringify({
          event: "download",
          file_url: encodeURI(`${axios.defaults.baseURL}${url}`),
          file_name: nombreFichero,
        });

        console.log(
          `llamando al parent para para la descarga de un archivo personal: ${data}`,
        );

        target.postMessage(data, "*");

        return;
      }

      axios
        .request(config)
        .then((response) => {
          const blob = new Blob([response.data], {
            type: response.headers["content-type"],
          });
          saveAs(blob, nombreFichero); // con librería npm 'file-saver'
        })
        .catch((error) => {
          console.error("Error al descargar el archivo:", error);
        });

      // axios.request(config).then(response => {
      //   const downloadLink = document.createElement('a');

      //   downloadLink.href = window.URL.createObjectURL(response.data);
      //   downloadLink.download = nombreFichero;
      //   downloadLink.click();
      //   downloadLink.remove();
      //   setTimeout(() => window.URL.revokeObjectURL(downloadLink), 100);
      // })
      // .catch(error => {
      //   console.error('Error al descargar el archivo:', error);
      // });
    },
    descargarDocumentoGeneral({ commit, state }, datosDocumento) {
      const { documento } = datosDocumento;
      const nombreFichero = documento.split("\\General\\")[1];
      const documentoParam = encodeURIComponent(`General/${nombreFichero}`);
      const url = `/api/documento-general?documento=${documentoParam}`;
      const config = {
        method: "get",
        url: url,
        responseType: "blob",
      };

      if (state.modoApp) {
        const target =
          window["cordova_iab"] ??
          window["webkit"]?.messageHandlers["cordova_iab"] ??
          window["opener"] ??
          window["parent"] ??
          window;

        const data = JSON.stringify({
          event: "download",
          file_url: `${axios.defaults.baseURL}${url}`,
          file_name: nombreFichero,
        });

        console.log(
          `llamando al parent para para la descarga de un archivo general: ${data}`,
        );

        target.postMessage(data, "*");

        return;
      }

      axios
        .request(config)
        .then((response) => {
          const blob = new Blob([response.data], {
            type: response.headers["content-type"],
          });
          saveAs(blob, nombreFichero); // con librería npm 'file-saver'
        })
        .catch((error) => {
          console.error("Error al descargar el archivo:", error);
        });

      // axios.request(config).then(response => {
      //   const downloadLink = document.createElement('a');

      //   downloadLink.href = window.URL.createObjectURL(response.data);
      //   downloadLink.download = nombreFichero;
      //   downloadLink.click();
      //   downloadLink.remove();
      //   setTimeout(() => window.URL.revokeObjectURL(downloadLink), 100);
      // })
      // .catch(error => {
      //   console.error('Error al descargar el archivo:', error);
      // });
    },
    establecerEstadoDocumentoGeneral({ commit }, datosDocumento) {
      const { idDocumento, ...datos } = datosDocumento;

      // console.log("estableciendoEstadoDocumentoGeneral");

      const config = {
        method: "put",
        url: `/api/estadoDocumentoGeneral/${idDocumento}`,
        data: datos,
      };

      axios
        .request(config)
        .then((response) => {
          // console.log('--------response---------');
          // console.log(response);
          // console.log('-------------------------');
          commit("actualizarFicheros", response.data);
        })
        .catch((error) => {
          console.error(error);
          throw error;
        });
    },
    obtenerDatosSolicitudVacacionesParaValoracion({ commit }, datos) {
      const { id_vacaciones } = datos;
      const config = {
        method: "get",
        url: `/api/datosVacacionesParaValoracion/${id_vacaciones}`,
      };

      axios
        .request(config)
        .then((response) => {
          // console.log(JSON.stringify(response));
          if (response.data.message) {
            return commit(
              "establecerdatosVacacionesParaValoracion",
              response.data,
            );
          }
          response.data[0][0].id_comunicacion = id_vacaciones;
          commit(
            "establecerdatosVacacionesParaValoracion",
            response.data[0][0],
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },
    enviarValoracionSolicitudVacaciones({ commit }, datos) {
      const config = {
        method: "post",
        url: "/api/valoracionResponsableVacaciones",
        data: datos,
      };

      commit("establecerEstadoEnviandoDatosFormulario", true);

      axios
        .request(config)
        .then((response) => {
          // console.log(response);
          commit("establecerEstadoEnviandoDatosFormulario", false);
          commit("establecerGuardadoOK", true);
        })
        .catch((error) => {
          commit("establecerEstadoEnviandoDatosFormulario", false);
          console.error(error);
          throw error;
        });
    },
    renovarToken({ commit, state }) {
      if (!state.token) return;

      try {
        const data = qs.stringify({
          tokenActual: state.token,
        });

        const config = {
          method: "post",
          url: "/api/renovar-token",
          data: data,
        };

        axios.defaults.headers.common["access-token"] = state.token;

        axios.request(config).then((response) => {
          // Actualiza el token en el estado de Vuex con el nuevo token renovado
          // console.log('nuevo token:', response.data.token );
          // console.log('state.token recibido:', response.data.token);
          commit("establecerToken", response.data.token);
        });
      } catch (error) {
        console.error("Error al renovar el token:", error);
        // Maneja errores de renovación de tokens, por ejemplo, redirige al usuario a la página de inicio de sesión
      }
    },
    async comprobarExpiracionToken({ commit, state }) {
      // console.log('comprobandoExpiracionToken');

      if (!state.token) {
        return; // No hay token para verificar
      }

      const tiempoExpiracionToken = jwtDecode(state.token).exp * 1000; // Timestamp de expiración del token en milisegundos
      const momentoActual = Date.now();

      // console.log('tiempoExpiracionToken:',tiempoExpiracionToken);
      // console.log('momentoActual:',momentoActual);

      // Verifica si el token tiene menos de 5 minutos de tiempo restante
      if (tiempoExpiracionToken - momentoActual < 5 * 60 * 1000) {
        commit("cerrarSesion");
        commit("limpiarPerfil");
      }
    },
    comprobarStatus({ commit, state }) {
      const config = {
        method: "get",
        url: "/api/status",
      };

      axios.request(config).then((response) => {
        commit("establecerStatus", response.data.status);
      });
    },
  },
  modules: {},
  plugins: [createPersistedState()],
});

// Configura un temporizador para verificar el token cada X minutos
setInterval(() => {
  store.dispatch("comprobarExpiracionToken"); // Llama a la acción para verificar el token
}, 1 * 60 * 1000); // Verifica cada 5 minutos (ajusta este valor según tus necesidades)

export default store;
